'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './e-form-list.routes';

export class EFormListComponent {
  constructor(Auth, EFormsService, dialogs, $uibModal, $stateParams, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.EFormsService = EFormsService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.formName = $stateParams.name;

    this.EFormsService.query(data => {
      this.systemForms = [{
        _id: 'contact',
        system: true,
        name: 'Contact Form'
      },{
        _id: 'feedback',
        system: true,
        name: 'Feedback Form'
      }];
      this.data = this.systemForms.concat(data);
    }, err => {
      console.log("Could not retrieve e-forms.")
    })
  }

  delete(eform) {
    var that = this;

    var eformText = "<br/><br/><b>E-Form </b><br/><p>" + eform.name + "</p>";

    var dlg = this.dialogs.confirm("Delete E-Form?", "Do you really want to delete the e-form?" + eformText);
    dlg.result.then(() => {
      // OK delete it
      that.EFormsService.delete({id: eform._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== eform._id;
          });
        },
        err => {
          alert("Could not delete e-form");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.eForms.eFormList', [uiRouter])
  .config(routes)
  .component('eFormList', {
    template: require('./e-form-list.html'),
    controller: EFormListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/e-form/list/e-form-list.component.js